import React, { useEffect, useState } from 'react';
import {
  Box,
  makeStyles,
  Typography,
  Paper,
  Button
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useCookies } from 'react-cookie';
import { useCallback } from 'react';

const useStyles = makeStyles((theme) => ({
  popup: {
    width: '320px',
    margin: 'auto',
    padding: '20px 15px',
    borderRadius: 16,
    position: 'relative',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    [theme.breakpoints.down('md')]: {
      padding: '15px 10px',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    '&>div': {
      padding: 5,
    },
  },
  cont: {
    position: 'fixed',
    zIndex: 100,
    top: 20,
    right: 20,
    visibility: 'hidden',
    transition: 'transform 0.4s ease-in-out, visibility 0.2s 0.4s ease-in',
    transform: 'translate(0, -150%)',
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  activeCookie: {
    visibility: 'visible',
    transition: 'transform 0.4s ease-in-out',
    transform: 'translate(0, 0)',
  },
  title: {
    fontWeight: 900,
    marginBottom: 10,
  }
}));

const CookiesComponent = (props) => {
  const classes = useStyles();
  const [cookies, setCookie] = useCookies(['popup-shown']);
  const [canShow, setCanShow] = useState(false);
  const { t } = useTranslation();
  const close = useCallback(() => {
    setCookie('popup-shown', true, {
      expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    });
  }, [setCookie]);

  useEffect(() => {
    const scrollCheck = () => {
      if (!canShow && window.pageYOffset >= 100 && !cookies['popup-shown']) {
        setCanShow(true);
      }
    };
    window.addEventListener('scroll', scrollCheck);
    return () => {
      window.removeEventListener('scroll', scrollCheck);
    };
    // eslint-disable-next-line
  }, [cookies]);
  return (
    <Box
      className={`${classes.cont} ${
        !cookies['popup-shown'] && canShow ? classes.activeCookie : ''
      }`}
      maxWidth="md"
    >
      <Paper className={classes.popup}>
        <Box className={classes.contentBox}>
          <Typography className={classes.title}>{t('popup.title')}</Typography>
          <Typography>{t('popup.content')}</Typography>
        </Box>
        <Box>
          <Button
            color="primary"
            variant="outlined"
            onClick={close}
          >
            {t('popup.accept')}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default React.memo(CookiesComponent);
